import { useModals } from 'almanac-ui/Modal'
import { WeeklyPostLimitReachedModal } from './WeeklyPostLimitReachedModal'

export const WEEKLY_POST_LIMIT_ERROR_CODE = 'weekly_post_limit_reached'

type OpenModal = ReturnType<typeof useModals>['openModal']
type CloseAllModals = ReturnType<typeof useModals>['closeAllModals']

export const openWeeklyPostLimitModal = (openModal: OpenModal, closeAllModals: CloseAllModals) => {
  closeAllModals()
  openModal(WeeklyPostLimitReachedModal, {})
}
